import { createFileRoute } from '@tanstack/react-router';

import { RolesView } from '../../administracja/RolesView';

export const Route = createFileRoute('/administracja/role')({
  component: RolesView,
});
